import { PosProduct, Product, ProductLink, Venue } from 'generated/graphql';
import { createContext, useContext } from 'react';
import { type ReducerAction } from 'types';

export type ItemContextProps = {
  item: Product | null;
  productLink: ProductLink | null;
  posProduct: PosProduct | null;
  handleChange: (args: ReducerAction) => void;
  currentVenue?: Venue | undefined | null;
};

export const ItemContext = createContext<ItemContextProps | null>(null);

export const useItemContext = (): ItemContextProps => {
  return useContext(ItemContext) as ItemContextProps;
};
